import React, { useState, useContext } from "react";
import { Row, Col, Card } from "react-bootstrap";
import classes from "./HomeComponent.module.css";
import MenuDisplayPage from "./MenuDisplayPage";
import LoginPage from "./LoginPage";
import PermissionContext from "../../Store/permission-context";
// import bg4 from "./Images/bg4.jpg";

const HomeComponent = () => {
  const PCtx = useContext(PermissionContext);
  const [FooterDetails, setFooterDetails] = useState([
    {
      header: "ABOUT US",
      body:
        "Contact us for your juice, wine, whiskey, vodka, rum, gin, tequila, brandy and any type of quality liquor.",
    },
    {
      header: "OUR ADDRESS",
      body:
        "Alalubosa Area, Opposite Periola Junction, Atiba road, Oyo, Oyo State.",
    },
    {
      header: "CONTACT US",
      body: "PHONE NUMBER: 08066404718, 09055763838, 09066647442",
    },
    {
      header: " OUR SOFTWARE DEVELOPER",
      body: "APPLAUSE INFOTECH",
      tel: "TELEPHONE: 08033824233",
      email: "EMAIL: applausebiz@gmail.com",
    },
  ]);

  return (
    <Row>
      <Col md={12} sm={12} xs={12}>
        <Row>
          <Col md={12} sm={12} className="p-0 m-0" xs={12}>
            <Card>
              <Card.Body>
                <h3 className={classes.CompanyName}>
                  HAPPINESS & JOY D & D STORE
                </h3>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {PCtx.logged ? <MenuDisplayPage /> : <LoginPage />}
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Card>
              <Card.Body>
                <Row>
                  {FooterDetails.map((ft, index) => (
                    <Col md={3} sm={12} xs={12}>
                      <h5 className={classes.fth}>{ft.header}</h5>
                      <hr className="my-1 " />
                      <p className="text-justify">{ft.body}</p>
                      {ft.tel && <p className="text-justify">{ft.tel}</p>}
                      {ft.email && <p className="text-justify">{ft.email}</p>}
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default HomeComponent;
